import Alpine from 'alpinejs';
import initComponents from './components';

document.addEventListener('alpine:init', () => {
  initComponents();
});

window.Alpine = Alpine;
Alpine.start();
